const ACTION_SCOPE = '[Applications]';
export class GenerateApplications {
  static readonly type = `${ACTION_SCOPE} Generate Applications`;
  constructor(public payload: { examId: string, numberOfApplications: number }) { }
}
export class GetUserApplications {
  static readonly type = `${ACTION_SCOPE} Get User Applications`;
  constructor(public userId: string) { }
}
export class AddApplication {
  static readonly type = `${ACTION_SCOPE} Add User Application`;
  constructor(public payload: any) { }
}
export class CheckIsUserHasRegistrationsToExamType {
  static readonly type = `${ACTION_SCOPE} Check Status of User Application`;
  constructor(public payload: any) { }
}

export class GetApplicationsByExam{
    static readonly type = `${ACTION_SCOPE} Get Application By Exam Id`;
  constructor(public payload: string) { }
}
